module.exports = __webpack_public_path__ + "img/create_code_btn.bb439209.png";